import React, { useState, useContext, Fragment } from 'react';
import { TextField } from '@fluentui/react';
import htmr from 'htmr';
function FreeAnswer(props) {

    const handleDescriptionChange = (event) => {
        props.setValue(event.target.value)
    }

    return (
        <div className="flexcolumn displayflex flex1 quiz-container">
            <div style={{ fontSize: 16 }}>
                {htmr(props.data.question)}
            </div>
            <div className="displayflex flex1 width100 mt20" style={{ maxWidth: 600 }}>
                <form className="default-form width100">
                    <div class="form-group width100">
                        <TextField value={props.value} multiline rows={3} className="width100" onChange={handleDescriptionChange} />
                    </div>
                </form>
            </div>
        </div>
    );
}

export default FreeAnswer;